import React from "react";
import { Tooltip } from "@mui/material";

interface CellRateProps {
  children: string | number;
}

const CellRate = ({ children }: CellRateProps) => {
  // Convert children to a number safely
  const rawValue =
    typeof children === "string" ? parseFloat(children) : children;
  const ratingValue = isNaN(rawValue) ? 0 : rawValue;
  // If it's <= 1, consider it as a fraction and multiply by 100
  const displayValue = ratingValue <= 1 ? ratingValue * 100 : ratingValue;

  // Round to two decimal places for display text
  const formattedValue = displayValue.toFixed(2);

  // Styles for the progress bar container
  const containerStyle: React.CSSProperties = {
    width: "100%",
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    overflow: "hidden",
    height: "20px",
    position: "relative"
  };

  // Styles for the grey filled part of the bar
  const fillerStyle: React.CSSProperties = {
    height: "100%",
    width: `${formattedValue}%`,
    backgroundColor: "grey",
    transition: "width 0.5s ease"
  };

  // Style for the centered percentage text
  const labelStyle: React.CSSProperties = {
    position: "absolute",
    width: "100%",
    textAlign: "center",
    top: "0",
    lineHeight: "20px",
    color: "black",
    fontWeight: "bold",
    fontSize: "0.9rem"
  };

  return (
    <Tooltip title={`Rate: ${ratingValue}`}>
      <div style={containerStyle}>
        <div style={fillerStyle} />
        <div style={labelStyle}>{formattedValue}%</div>
      </div>
    </Tooltip>
  );
};

export default CellRate;
